import React from 'react';
import clsx from 'clsx';
import { CloseIcon } from '../../assets/icons';
import CheckIcon from '../../assets/icons/check.svg';
import './Switch.css';

const Switch = ({ onToggle, isOn }) => {
  return <button className={clsx('switch', isOn && 'switch_on' )} onClick={onToggle}>
    <div className={clsx('toggle', isOn && 'toggle_on')}>
      {
        isOn ? <img src={CheckIcon} alt="Checkbox" /> : <CloseIcon />
      }
    </div>
  </button>;
}

export default Switch;
